<template>
  <div>
    <!-- MODO TELA: escolher ordenação e executar -->
    <div v-if="!printMode">
      <h6>Pendências – Forma de Pagamento = “A informar”</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Ordenar por:</label>
          <select v-model="ordenacaoLocal" class="form-control">
            <option value="descricao">Descrição (padrão)</option>
            <option value="vencimento">Vencimento</option>
            <option value="refil">Refil</option>
          </select>
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- MODO IMPRESSÃO -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( Ordenação: {{ labelOrdenacao(ordenacao) }} )
      </p>

      <div v-if="loading">Carregando…</div>
      <div v-else>
        <div v-if="receitas.length">
          <h6>Pagamentos Pendentes</h6>
          <table class="table table-striped mb-2">
            <thead>
              <tr>
                <th>Refil</th>
                <th>Descrição</th>
                <th>Vencimento</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in receitas" :key="'pend-' + i">
                <td>{{ item.refil }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ globalUtils.formatarData(item.vencimento) }}</td>
                <td class="text-right">{{ formatarMoeda(item.valor) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3"><strong>Total</strong></td>
                <td class="text-right"><strong>{{ formatarMoeda(totais.valor) }}</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else class="text-muted">Nenhuma pendência encontrada.</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/services/axios'
import { useRouter } from 'vue-router'
import globalUtils from '@/utils/globalUtils.js';

const props = defineProps({
  printMode:  Boolean,
  printTitle: { type: String,  default: 'Relatório' },
  subtitle:   { type: String,  default: '' },
  ordenacao:  { type: String,  default: 'descricao' }
})

const router       = useRouter()
const loading      = ref(false)
const receitas     = ref([])
const totais       = ref({ valor: 0 })
const ordenacaoLocal = ref('descricao')

onMounted(async () => {
  if (!props.printMode) return
  loading.value = true
  try {
    const { data } = await axios.get('/gestao/relatorios/financeiros/pendencias', {
      params: { ordenacao: props.ordenacao || 'descricao' }
    })
    receitas.value = data.receitas || []
    totais.value   = data.totais   || { valor: 0 }
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
})

function abrirPrint() {
  const ord = ordenacaoLocal.value || 'descricao'
  const legenda = `Ordenação: ${labelOrdenacao(ord)}`
  router.push({
    path: '/gestao/relatorios/print/receitas-pendencias',
    query: {
      title:     'Pendências – Forma de Pagamento = “A informar”',
      ordenacao: ord,
      subtitle:  `( ${legenda} )`
    }
  })
}

function labelOrdenacao(v) {
  if (v === 'vencimento') return 'Vencimento'
  if (v === 'refil')      return 'Refil'
  return 'Descrição'
}

function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
</script>

<style scoped>
.mb-3 { margin-bottom: 1rem; }
.text-right { text-align: right !important; }
</style>
